export enum OwnDataStatus {
    COMPLETED = 'completed',
    PARTIAL_COMPLETED = 'partial completed',
    FAILED = 'failed',
    IN_PROGRESS = 'in progress',
    INITIATED = 'initiated',
    DOCUMENT_READY = 'document_ready',
    DOCUMENT_PARSING = 'document_parsing',
    VECTOR_SEARCH = 'vector_search',
    LLM_PROCESSING = 'llm_processing',
    DOCUMENT_TRANSLATION = 'document_translation',
    QUESTION_CLASSIFICATION = 'question_classification',
    PARTIAL_FAILURE = 'partial_failure',
}

export const StatusLabels = {
    initiated: 'Initiated',
    document_parsing: 'Document Parsing',
    question_classification: 'Question Classification ',
    vector_search: 'Vector Search',
    llm_processing: 'LLM Processing',
    document_ready: 'Document Ready',
    partial_failure: 'Partial Failure',
    document_translation: 'Document Translation',
    failed: 'Failed',
};
